import {
  CampoLayout,
  CHAVES_DO_LAYOUT_EDITADAS_NA_TELA,
  DetalhesLayout,
  Layout
} from "./repositorio/e02.layout.interface";

import { Categorias, TipoDeArquivo } from "./dominio/e02.enum";
import { formatarCampos, formatarSeparadorParaEnvio, formatarSeparadorParaLeitura, separarCampoESubcampo } from "./utilitarios";
import { gerarIdRandomico } from '@/utils/criadoras/criadoras.js';

import { ServicoHttpCondominio } from "@/main";
import { LayoutE02Repositorio } from "./repositorio/e02.repositorio";
import { LayoutE02Servico } from "./dominio/e02.dominio";
import { IRequestCriarLayout } from "./repositorio/e02.repositorio.request";

export const montarServicoLayoutE02 = () => {
  const http = ServicoHttpCondominio
  const layoutE02Repositorio = new LayoutE02Repositorio(http);
  const layoutE02Servico = new LayoutE02Servico(layoutE02Repositorio);

  return layoutE02Servico;
}

// codigo e nome_software_pagamento serão implementados na v2
interface IStateLayoutE02 {
  layout_id: string;
  nome: string;
  // codigo: number | null;
  empresa: string;
  // nome_software_pagamento: string;
  layout: Layout;
  chavesDoLayoutNaoEditadasNaTela: Record<string, unknown>;
}

const statePadrao = (): IStateLayoutE02 => ({
  layout_id: '',
  nome: '',
  // codigo: null,
  empresa: '',
  // nome_software_pagamento: '',
  layout: {
    formato_do_arquivo: null,
    separador_de_campos: null,
    quantidade_de_espaco: null,
    campos: [],
    extensao_do_arquivo: null,
    quebra_de_linha_txt: null,
    usar_aspas_para_texto_csv: null,
    campos_do_cabecalho: [],
    omitir_falta_em_apontamentos_por_verbas: false
  },
  chavesDoLayoutNaoEditadasNaTela: {},
});

const formatarCampoParaEdicao = (campo: CampoLayout): CampoLayout => {
  const { campoPrincipal, subCampo } = separarCampoESubcampo(campo.campo);

  let campoPrincipalFormatado = campoPrincipal;

  // se o campo principal for 'empregado' e o subcampo começar com 'empregador.',
  // então o campo principal formatado deve ser 'empregador'
  // para popular os seletores de configuração corretamente
  if (campoPrincipal === Categorias.Empregado && subCampo.startsWith('empregador.')) {
    campoPrincipalFormatado = Categorias.Empregador;
  }

  return {
    ...campo,
    campo: campoPrincipalFormatado,
    subCampo,
  };
};

const mutations = {
  resetarEstado(state: IStateLayoutE02) {
    Object.assign(state, statePadrao());
  },
  definirLayoutId(state: IStateLayoutE02, layoutId: string) {
    state.layout_id = layoutId;
  },
  definirNomeLayout(state: IStateLayoutE02, nome: string) {
    state.nome = nome;
  },
  // definirCodigo(state: IStateLayoutE02, codigo: number) {
  //   state.codigo = codigo || null;
  // },
  definirEmpresaId(state: IStateLayoutE02, empresa: string) {
    state.empresa = empresa;
  },
  // definirNomeSoftwarePagamento(state: IStateLayoutE02, nomeSoftwarePagamento: string) {
  //   state.nome_software_pagamento = nomeSoftwarePagamento || '';
  // },
  definirConfiguracaoDoArquivo(state: IStateLayoutE02, configuracaoArquivo: Layout) {
    state.layout.formato_do_arquivo = configuracaoArquivo.formato_do_arquivo;
    state.layout.separador_de_campos = configuracaoArquivo.separador_de_campos;
    state.layout.quantidade_de_espaco = configuracaoArquivo.quantidade_de_espaco;
    state.layout.extensao_do_arquivo = configuracaoArquivo.extensao_do_arquivo;
    state.layout.quebra_de_linha_txt = configuracaoArquivo.quebra_de_linha_txt;
    state.layout.usar_aspas_para_texto_csv = configuracaoArquivo.usar_aspas_para_texto_csv;
  },
  adicionarCampo(state: IStateLayoutE02, campo: CampoLayout) {
    const novoCampo = {
      ...campo,
      id: gerarIdRandomico()
    }
    state.layout.campos.push(novoCampo);
  },
  sincronizarOrdem(state: IStateLayoutE02, campos: CampoLayout[]) {
    state.layout.campos = [...campos];
  },
  atualizarCampo(state: IStateLayoutE02, campoAtualizado: CampoLayout) {
    const indexDoArray = state.layout.campos.findIndex(campo => campo.id === campoAtualizado.id);
    if (state.layout.campos[indexDoArray]) {
      state.layout.campos[indexDoArray] = campoAtualizado;
    }
  },
  removerCampo(state: IStateLayoutE02, id: string) {
    const indexDoArray = state.layout.campos.findIndex(campo => campo.id === id);
    if (state.layout.campos[indexDoArray]) {
      state.layout.campos.splice(indexDoArray, 1);
    }
  },
  adicionarCampoDoCabecalho(state: IStateLayoutE02, campo: CampoLayout) {
    state.layout.campos_do_cabecalho = [
      ...(state.layout.campos_do_cabecalho || []),
      { ...campo, id: gerarIdRandomico() }
    ];
  },
  sincronizarOrdemDoCabecalho(state: IStateLayoutE02, campos: CampoLayout[]) {
    state.layout.campos_do_cabecalho = [...campos];
  },
  atualizarCampoDoCabecalho(state: IStateLayoutE02, campoAtualizado: CampoLayout) {
    const campos = state.layout.campos_do_cabecalho || [];
    const indexDoArray = campos.findIndex(campo => campo.id === campoAtualizado.id);
    if (campos[indexDoArray]) {
      campos[indexDoArray] = campoAtualizado;
    }
  },
  removerCampoDoCabecalho(state: IStateLayoutE02, id: string) {
    state.layout.campos_do_cabecalho = (state.layout.campos_do_cabecalho || []).filter(
      campo => campo.id !== id
    );
  },
  definirChavesDoLayoutNaoEditadasNaTela(state: IStateLayoutE02, chaves: Record<string, unknown>) {
    state.chavesDoLayoutNaoEditadasNaTela = chaves;
  },
  definirOmitirFaltaConsolidada(state: IStateLayoutE02, omitir: boolean) {
    state.layout.omitir_falta_em_apontamentos_por_verbas = omitir;
  }
};

const actions = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async salvarLayoutAction({ state, rootState }: { state: IStateLayoutE02, rootState: any }) {
    const { layout_id, nome, layout, chavesDoLayoutNaoEditadasNaTela } = state;
    const { 
      formato_do_arquivo, 
      separador_de_campos, 
      quantidade_de_espaco, 
      campos,
      extensao_do_arquivo,
      quebra_de_linha_txt,
      usar_aspas_para_texto_csv,
      campos_do_cabecalho,
      omitir_falta_em_apontamentos_por_verbas
    } = layout;

    try {
      const payloadRequisicao: IRequestCriarLayout = {
        nome,
        empresa: rootState.userInfo.compMan.postgresId,
        layout: {
          ...chavesDoLayoutNaoEditadasNaTela,
          formato_do_arquivo,
          campos: formatarCampos(campos),
          extensao_do_arquivo: extensao_do_arquivo || null,
          quebra_de_linha_txt: quebra_de_linha_txt || null,
          usar_aspas_para_texto_csv: usar_aspas_para_texto_csv || false,
          campos_do_cabecalho: formatarCampos(campos_do_cabecalho || []),
          omitir_falta_em_apontamentos_por_verbas: omitir_falta_em_apontamentos_por_verbas ?? false
        }
      }

      const tiposDeArquivosComSeparador = [TipoDeArquivo.Csv, TipoDeArquivo.Txt];
      if (
        formato_do_arquivo && 
        tiposDeArquivosComSeparador.includes(formato_do_arquivo) && 
        separador_de_campos
      ) {
        payloadRequisicao.layout.separador_de_campos = formatarSeparadorParaEnvio(separador_de_campos, quantidade_de_espaco);
      }

      // Se não for TXT, não faz sentido enviar extensão personalizada
      if (formato_do_arquivo !== TipoDeArquivo.Txt) {
         payloadRequisicao.layout.extensao_do_arquivo = null;
         payloadRequisicao.layout.quebra_de_linha_txt = null;
         // O backend só grava o cabeçalho por campos na 1ª linha do TXT
         payloadRequisicao.layout.campos_do_cabecalho = [];
      }
      
      // Se não for CSV, não faz sentido enviar aspas
      if (formato_do_arquivo !== TipoDeArquivo.Csv) {
         payloadRequisicao.layout.usar_aspas_para_texto_csv = false;
      }

      let resultado;

      if (state.layout_id) {
        const payloadRequisicaoEdicao = { ...payloadRequisicao, id: layout_id, empresa: state.empresa };
        resultado = await montarServicoLayoutE02().atualizarLayout(payloadRequisicaoEdicao);
      } else {
        resultado = await montarServicoLayoutE02().criarLayout(payloadRequisicao);
      }

      return resultado;
    } catch (error) {
      throw error;
    }
  },
  // @ts-expect-error contexto não tipado
  async obterLayoutPorId({ dispatch }, layoutId: string) {
    try {
      const resultado = await montarServicoLayoutE02().obterLayoutPorId({ layout_id: layoutId });
      if (resultado) {
        await dispatch('popularLayout', resultado);
        return resultado;
      }
    } catch (error) {
      throw error;
    }
  },
  // @ts-expect-error contexto não tipado
  popularLayout({ commit }, payload: DetalhesLayout) {
    commit('resetarEstado');

    commit('definirLayoutId', payload.id)
    commit('definirNomeLayout', payload.nome);
    commit('definirEmpresaId', payload.empresa);
    commit('definirOmitirFaltaConsolidada', payload.layout.omitir_falta_em_apontamentos_por_verbas ?? false);
    // serão implementados na v2
    // commit('definirCodigo', payload.codigo); 
    // commit('definirNomeSoftwarePagamento', payload.nome_software_pagamento);

    const { separador, qtdEspacos } = formatarSeparadorParaLeitura(payload.layout.separador_de_campos || null);
    commit('definirConfiguracaoDoArquivo', {
      formato_do_arquivo: payload.layout.formato_do_arquivo || null,
      separador_de_campos: separador || null,
      quantidade_de_espaco: qtdEspacos || null,
      extensao_do_arquivo: payload.layout.extensao_do_arquivo || null,
      quebra_de_linha_txt: payload.layout.quebra_de_linha_txt || null,
      usar_aspas_para_texto_csv: payload.layout.usar_aspas_para_texto_csv ?? false,
    });

    payload.layout.campos.forEach((campo: CampoLayout) => {
      commit('adicionarCampo', formatarCampoParaEdicao(campo));
    });

    (payload.layout.campos_do_cabecalho || []).forEach((campo: CampoLayout) => {
      commit('adicionarCampoDoCabecalho', formatarCampoParaEdicao(campo));
    });

    const chavesNaoEditadasNaTela = Object.fromEntries(
      Object.entries(payload.layout).filter(
        ([chave]) => !CHAVES_DO_LAYOUT_EDITADAS_NA_TELA.includes(chave)
      )
    );
    commit('definirChavesDoLayoutNaoEditadasNaTela', chavesNaoEditadasNaTela);
  }
};

export default {
  namespaced: true,
  state: statePadrao(),
  mutations,
  actions,
};
